import React from "react";
import { useMsal } from "@azure/msal-react";
import { LogOut } from "lucide-react";

export const SignOutRedirectButton = () => {
    const { instance } = useMsal();
    
    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }
    
    return (
        <button 
            onClick={handleLogout}
            className=" flex items-center space-x-2 py-2 px-4 rounded-full hover:bg-gray-200 transition-colors duration-200"
        >
            <LogOut size={20} />
            <span>Odhlásit</span>
        </button>
    )
}

export default SignOutRedirectButton;